import React from 'react';
import { useFormikContext } from 'formik';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

export const DetailsStepNavigation: React.FC = () => {
  const { isValid } = useFormikContext();
  return (
    <div className={css({ display: 'grid', justifyItems: 'end' })}>
      <Button tone={'brand'} emphasis={'filled'} size="sm" type="submit" disabled={!isValid}>
        Next
      </Button>
    </div>
  );
};
